import { render, staticRenderFns } from "./KintaiPatternPage.vue?vue&type=template&id=1fa9cb2d&scoped=true&"
import script from "./KintaiPatternPage.vue?vue&type=script&lang=ts&"
export * from "./KintaiPatternPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa9cb2d",
  null
  
)

export default component.exports